;(function ( $ ) {

    /**
     *  optInAccept
     *  sets opt-in to true when user clicks
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'optInAccept';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.optInUrl = $('body').data('opt-in-url');
            if (!this.optInUrl) {
                return;
            }
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(this.element).on('click', function(e) {
                e.preventDefault();
                if ($('body').data('opt-in-trigger')) {
                    // trigger server call
                    $.ajax({
                        url: $('body').data('opt-in-trigger'),
                        method: 'POST',
                        success: function(e) {}
                    });
                }
                window.optInOrderTerms = true;
                $('body').data('opt-in', true);
                var extraParams = {};
                extraParams.bg = 'gray';
                extraParams.href = window.optInUrlAfter;
                window.optInUrlAfter = false;
                $(document).trigger('overlay.show', extraParams);
            });
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
